export default __webpack_public_path__ + "banner-framework277533.png";